<div *ngIf="loading" class="d-flex justify-content-center align-items-center py-5">
    <mat-spinner></mat-spinner>
</div>

<ng-container *ngIf="!loading">
    <div *ngIf="paymentLogs.length === 0" class="text-center text-muted py-4">
        {{ 'NO_PAYMENT_HISTORY' | translate }}
    </div>

    <table mat-table *ngIf="paymentLogs.length > 0"
           [dataSource]="paymentLogsDataSource"
           class="mat-elevation-z2 full-width-table">

        <ng-container matColumnDef="created_at">
            <th mat-header-cell *matHeaderCellDef> {{ 'CREATED_AT' | translate }} </th>
            <td mat-cell *matCellDef="let log">
                {{ (log.created_at | date:'dd/MM/yyyy HH:mm') || '-' }}
            </td>
        </ng-container>

        <ng-container matColumnDef="bank_name">
            <th mat-header-cell *matHeaderCellDef> {{ 'BANK_NAME' | translate }} </th>
            <td mat-cell *matCellDef="let log">
                {{ log.bank_name || '-' }}
            </td>
        </ng-container>

        <ng-container matColumnDef="bank_account_holder_name">
            <th mat-header-cell *matHeaderCellDef> {{ 'Bank Account Holder Name' | translate }} </th>
            <td mat-cell *matCellDef="let log">
                {{ log.bank_account_holder_name || '-' }}
            </td>
        </ng-container>

        <ng-container matColumnDef="bank_account_number">
            <th mat-header-cell *matHeaderCellDef> {{ 'Bank Account Number' | translate }} </th>
            <td mat-cell *matCellDef="let log">
                {{ log.bank_account_number || '-' }}
            </td>
        </ng-container>

        <ng-container matColumnDef="paid_amount">
            <th mat-header-cell *matHeaderCellDef> {{ 'Payment Amount' | translate }} </th>
            <td mat-cell *matCellDef="let log">
                Rp {{ log.paid_amount | number }}
            </td>
        </ng-container>

        <ng-container matColumnDef="payment_date">
            <th mat-header-cell *matHeaderCellDef> {{ 'Payment Date' | translate }} </th>
            <td mat-cell *matCellDef="let log">
                {{ (log.payment_date | date:'dd/MM/yyyy') || '-' }}
            </td>
        </ng-container>

        <ng-container matColumnDef="payment_notes">
            <th mat-header-cell *matHeaderCellDef> {{ 'Payment Notes' | translate }} </th>
            <td mat-cell *matCellDef="let log">
                {{ log.payment_notes || '-' }}
            </td>
        </ng-container>

        <ng-container matColumnDef="status">
            <th mat-header-cell *matHeaderCellDef> {{ 'Status' | translate }} </th>
            <td mat-cell *matCellDef="let log">
                <span class="badge"
                    [ngClass]="{
                        'bg-warning text-dark': log.status === 'pending',
                        'bg-success': log.status === 'approved',
                        'bg-danger': log.status === 'rejected',
                        'bg-secondary': log.status === 'canceled'
                    }">
                    {{ ('PAYMENT_STATUS_' + (log.status | uppercase)) | translate }}
                </span>
            </td>
        </ng-container>

        <ng-container matColumnDef="reject_reason">
            <th mat-header-cell *matHeaderCellDef> {{ 'REJECT_REASON' | translate }} </th>
            <td mat-cell *matCellDef="let log">
                {{ log.reject_reason || '-' }}
            </td>
        </ng-container>

        <ng-container matColumnDef="payment_slip">
            <th mat-header-cell *matHeaderCellDef> {{ 'Payment Slip' | translate }} </th>
            <td mat-cell *matCellDef="let log">
                <a *ngIf="log.payment_slip?.url" [href]="log.payment_slip.url" target="_blank" class="text-primary">
                    {{ 'VIEW_PAYMENT_SLIP' | translate }}
                </a>
                <span *ngIf="!log.payment_slip?.url">-</span>
            </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="columnsToDisplay"></tr>
        <tr mat-row *matRowDef="let row; columns: columnsToDisplay;"></tr>
    </table>
</ng-container>
